// Helper to open WhatsApp: try intent (Android Chrome) -> whatsapp:// -> api.whatsapp -> web.whatsapp
export function openWhatsApp(phone, message) {
  const cleanPhone = String(phone || '').replace(/\D/g, '');
  const encoded = encodeURIComponent(message || 'Hello');

  const intentLink = `intent://send?phone=${cleanPhone}&text=${encoded}#Intent;package=com.whatsapp;scheme=whatsapp;end`;
  const appLink = `whatsapp://send?phone=${cleanPhone}&text=${encoded}`;
  const apiLink = `https://api.whatsapp.com/send?phone=${cleanPhone}&text=${encoded}`;
  const webLink = `https://web.whatsapp.com/send?phone=${cleanPhone}&text=${encoded}`;

  const ua = navigator.userAgent || '';
  const isAndroid = /Android/i.test(ua);
  const isIOS = /iPhone|iPad|iPod/i.test(ua);
  const isChrome = /Chrome\//i.test(ua) && !/Edge\//i.test(ua);

  // Android Chrome can use intent:// which reliably opens the app
  if (isAndroid && isChrome) {
    window.location.href = intentLink;
    setTimeout(() => {
      // fallback to web API if app not installed / intent failed
      window.location.href = apiLink;
    }, 800);
    return;
  }

  // iOS and other mobile: try app protocol first, then fallback to api
  if (isAndroid || isIOS) {
    // Attempt app protocol
    try {
      window.location.href = appLink;
    } catch (e) {
      // ignore
    }

    setTimeout(() => {
      window.location.href = apiLink;
    }, 800);
    return;
  }

  // Desktop: open web.whatsapp.com in new tab
  window.open(webLink, '_blank', 'noopener,noreferrer');
}

export default openWhatsApp;
